// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TwUL","col":"styles_col__mBT_b","actions":"styles_actions__1NtNN","conflict":"styles_conflict__df9ZR"};